import * as S from './styles';
import { Button } from 'base/src/components/Button';
import { RootStateCarteira } from '../../../../store/carteiraReducer';
import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { formatToBRL } from 'base/src/utils/mathUtil';

const connector = connectUtil(
  (state: RootStateCarteira) => ({
    homeInfo: state.CarteiraBaseReducer.CarteiraBase,
    homeInfoCampanha: state.CarteiraBaseReducer.CarteiraBaseCampanha,
  }),
  { }
);

export interface CarteiraHomeComponentProps extends PropsFromRedux<typeof connector> {}

function SecondaryCard (props: CarteiraHomeComponentProps) {
  return (
    <S.Container>
      <S.TextContainer>
        <S.TitleContainer>
          <S.Title>Valor Pago</S.Title>
          <S.Value>{props.homeInfo.EsconderSaldo ? "R$ *****,**" : formatToBRL(props.homeInfo.ValorPago || 0)}</S.Value>
          <S.Subtitle></S.Subtitle>
        </S.TitleContainer>
        {/* <S.SubTitleContainer>
          <S.Subtitle>Pagamento(s) Pendente(s)</S.Subtitle>
          <S.SecondaryValue>{formatToBRL(props.homeInfo.SaldoBloqueado || 0)}</S.SecondaryValue>
        </S.SubTitleContainer> */}
      </S.TextContainer>
      <S.StyledLink to='/extrato' style={{ alignSelf: 'end' }}>
        <Button
          size='md'
        >
          Extrato
        </Button>
      </S.StyledLink>
    </S.Container>
  )
}

export default connector(SecondaryCard);